import { removeDeletedRowsIndividualMarkerSettingsSaga } from './consistency/removeDeletedRowsIndividualMarkerSettings.saga';

export function* mapSettingsMarkersGeneralSaga() {
  yield* removeDeletedRowsIndividualMarkerSettingsSaga();
}
